/* eslint-disable import/prefer-default-export */
import globalApi from '@/request/globalApi/globalApi'

const END_POINT = 'api/my-organizations'

export const fetchUserOrganizationsRequest = ({ params }) => globalApi.get(`${END_POINT}`, { params })
